import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/sidebar'
import { UserNav } from '@/components/user-nav'
import { ModeToggle } from '@/components/mode-toggle'
import { Input } from '@/components/ui/input'
import { MobileNav } from '@/components/mobile-nav'
import { NotificationDropdown } from '@/components/notifications/NotificationDropdown'

export default function DashboardLayout() {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1">
        <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="container flex h-14 max-w-full items-center gap-4 px-4">
            <MobileNav />
            <div className="flex flex-1 items-center gap-4">
              <Input
                type="search"
                placeholder="Buscar..."
                className="w-full md:max-w-[300px] lg:max-w-[400px]"
              />
            </div>
            <div className="flex items-center gap-2">
              <NotificationDropdown />
              <ModeToggle />
              <UserNav />
            </div>
          </div>
        </header>
        <main className="container max-w-full space-y-4 p-4 md:p-8 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

